import { render, staticRenderFns } from "./ShippingReportHead.vue?vue&type=template&id=0fe84cf0&scoped=true"
import script from "./ShippingReportHead.vue?vue&type=script&lang=js"
export * from "./ShippingReportHead.vue?vue&type=script&lang=js"
import style0 from "./ShippingReportHead.vue?vue&type=style&index=0&id=0fe84cf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe84cf0",
  null
  
)

export default component.exports